// extracted by mini-css-extract-plugin
module.exports = {"t1tlw9bm":"t1tlw9bm"};